<button
  *nodaResponsiveIf="[enMinWidthScreen.SM]"
  type="button"
  class="cart__closer"
  (click)="toggleClicked.emit()"
>
  <ng-container *ngTemplateOutlet="arrowTemplateRef()" />
</button>

<button
  *nodaResponsiveIf="[enMaxWidthScreen.SM]"
  type="button"
  class="cart__closer"
  (click)="toggleClicked.emit()"
>
  <assets-icon
    icon="close"
    class="icon-close"
  />
</button>

<div class="cart-wrap">
  <h4>
    <noda-translate
      class="inherit-font"
      [key]="'marketplace.cart.in-your-package'"
    />
  </h4>

  <span class="counter">
    <span>{{ counter() }}</span>
      <noda-translate
        class="inherit-font"
        [key]="'common.header.products'"
      />
  </span>

  <div>
    <button
      queryParamsHandling="preserve"
      tuiButton
      class="btn btn-start-using"
      [routerLink]="'/contact-sales' | addLangPrefix | async"
      (click)="startClicked.emit()"
    >
      <noda-translate
        class="inherit-font"
        [key]="'marketplace.cart.cta'"
      />
      <assets-icon
        icon="arrow_drop_right"
        [size]="22"
      />
    </button>
  </div>

  <div class="content content--selected">
    <div class="title"></div>
    <div class="list">
      @for (product of selectedProducts$ | async; track $index) {
        <noda-cart-product-card
          actionType="remove"
          [product]="product"
          [useSidebarStyles]="true"
          (toggle)="productToggleClicked.emit([product, $event])"
        />
      }
    </div>
  </div>

  <div class="content content--related">
    <span class="title">
      <noda-translate
        class="inherit-font"
        [key]="'marketplace.cart.recommended'"
      />
      <span>:</span>
    </span>

    <div class="list">
      @for (product of recommendedProducts$ | async; track $index) {
        <noda-cart-product-card
          actionType="add"
          [product]="product"
          [useRelatedStyles]="true"
          [useSidebarStyles]="true"
          (toggle)="productToggleClicked.emit([product, $event])"
        />
      }
    </div>
  </div>
</div>
